export class StartRegistrationRequest {
  public idUsuario: number;
  public versionAplicativo: string;
  public uuid: string;
  public email: string;
  public password: string;
  public telefono: string;
  public empresaTelefonia: string;
  public plataforma: string;
  public version: string;
  public descripcion: string;
  public recaptchaClientToken: string;
}
